import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {Favorite} from '@models/favorite';
import {User} from '@models/user';
import {EMPTY_USER} from '@models/empty';
import {AuthenticationService} from '@services/authentification.service';

@Component({
    selector: 'app-rendement-brut',
    templateUrl: './rendement-brut.component.html',
    styleUrls: ['./rendement-brut.component.scss']
})
export class RendementBrutComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;
    @Output() favoriteChange = new EventEmitter();
    user: User = Object.assign({}, EMPTY_USER);

    constructor(
        public authenticationService: AuthenticationService,
        public dialog: MatDialog) {
    }

    ngOnInit() {
        this.user = this.authenticationService.currentUser;
    }
}
